<!-- Start Navbar -->
<nav id="topnav" class="defaultscroll is-sticky">
  <div class="container">
      <!-- Logo container-->
      <a class="logo" href="index.html">
          <div class="block sm:hidden">
              <img src="assets/images/logo_long_cut_mobile_gold.png" class="h-10 inline-block dark:hidden"  alt="">
              <img src="assets/images/logo_long_cut_solo_gold.png" class="h-10 hidden dark:inline-block"  alt="">
          </div>
          <div class="sm:block hidden">
              <span class="inline-block dark:hidden">
                  <img src="assets/images/logo_long_cut_solo.png" class="h-[24px] l-dark" alt="">
                  <img src="assets/images/logo_long_cut_solo_gold.png" class="h-[24px] l-light" alt="">
              </span>
              <img src="assets/images/logo_long_cut_solo_gold.png" class="h-[24px] hidden dark:inline-block" alt="">
          </div>
      </a>
      <!-- End Logo container-->

      <!-- Start Mobile Toggle -->
      <div class="menu-extras">
          <div class="menu-item">
              <a class="navbar-toggle" id="isToggle" (click)="toggleMenu()">
                  <div class="lines">
                      <span></span>
                      <span></span>
                      <span></span>
                  </div>
              </a>
          </div>
      </div>
      <!-- End Mobile Toggle -->

      <!--Login button Start-->
      <!--<ul class="buy-button list-none mb-0">
          <li class="inline-block mb-0">
              <div class="relative top-[3px]">
                  <i class="uil uil-search text-lg absolute top-[3px] ltr:right-3 rtl:left-3"></i>
                  <input type="text" class="form-input h-9 ltr:pr-10 rtl:pr-10 rounded-3xl sm:w-44 w-36 border-gray-100 dark:border-slate-800 bg-white dark:bg-slate-900" name="s" id="searchItem" placeholder="Search...">
              </div>
          </li>
          <li class="inline-block pl-1 mb-0">
              <a href="" class="btn btn-icon rounded-full bg-emerald-600 hover:bg-emerald-700 border-emerald-600 hover:border-emerald-700 text-white"><img src="assets/images/team/05.jpg" class="rounded-full" alt=""></a>
          </li>
      </ul>-->
      <!--Login button End-->

      <div id="navigation">
          <!-- Navigation Menu-->
          <ul class="navigation-menu justify-end nav-light">
              <li class="has-submenu parent-menu-item">
                  <a routerLink="/home" (click)="toggleMenu()">Home</a>
                  <!--
                  <a href="javascript:void(0)">Mudico</a><span class="menu-arrow"></span>
                    <ul class="submenu">
                      <li><a href="index.html" class="sub-menu-item">Visie</a></li>
                      <li><a href="index-two.html" class="sub-menu-item">Vestigingen</a></li>
                      <li><a href="index-three.html" class="sub-menu-item">Hero Three</a></li>
                      <li><a href="index-four.html" class="sub-menu-item">Hero Four</a></li>
                      <li><a href="index-five.html" class="sub-menu-item">Hero Five</a></li>
                  </ul>
                -->
              </li>

              <li class="has-submenu parent-parent-menu-item"><a routerLink="/team" (click)="toggleMenu()"> Team </a></li>

              <li class="has-submenu parent-parent-menu-item"><a routerLink="/disciplines" (click)="toggleMenu()"> Disciplines </a></li>
                  <!--<a href="javascript:void(0)">Specialisaties</a><span class="menu-arrow"></span>
                  <ul class="submenu">
                      <li><a routerLink="/specialisaties" class="sub-menu-item">Specialisaties 1</a></li>
                      <li><a routerLink="/specialisaties-alt" class="sub-menu-item">Specialisaties 2</a></li>
                  </ul>-->

              <li class="has-submenu parent-parent-menu-item"><a routerLink="/vormingen" (click)="toggleMenu()"> Vormingen </a></li>

              <li class="has-submenu parent-parent-menu-item"><a routerLink="/praktisch" (click)="toggleMenu()"> Praktisch </a></li>

              <li><a routerLink="/contact" class="sub-menu-item" (click)="toggleMenu()">Contact</a></li>

              <!-- hover:border-earth-green hover:bg-earth-green  -->
              <li class="parent-parent-menu-item"><a href="https://www.facebook.com/mudico1" target="_blank"><i class="uil uil-facebook-f align-middle" title="facebook"></i></a></li>
              <li class="parent-parent-menu-item"><a href="https://www.instagram.com/groepspraktijk_mudico/" target="_blank"><i class="uil uil-instagram align-middle" title="instagram"></i></a></li>
          </ul><!--end navigation menu-->
      </div><!--end navigation-->
  </div><!--end container-->
</nav><!--end header-->
<!-- End Navbar -->
